import { render, staticRenderFns } from "./ReceptionQr.vue?vue&type=template&id=20ce5256&scoped=true&"
import script from "./ReceptionQr.vue?vue&type=script&lang=js&"
export * from "./ReceptionQr.vue?vue&type=script&lang=js&"
import style0 from "./ReceptionQr.vue?vue&type=style&index=0&id=20ce5256&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20ce5256",
  null
  
)

export default component.exports